'use strict';

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/
var thenable = require('../promise/thenable');
var constants = require('./constants');

var Context = function () {
  function Context() {
    (0, _classCallCheck3.default)(this, Context);

    this._map = {};
    this.constants = constants;
  }
  /**
   * Gets an item in the context instance or a promise if the item is not yet stored.
   * @param {string} name - The name of the item we want to get
   * @return any - The item we want to get.
   */


  (0, _createClass3.default)(Context, [{
    key: 'get',
    value: function get(name) {
      if (typeof name !== 'string' || typeof name === 'string' && !name.length) return; // Wrong usage, don't generate item promise.

      var item = this._map[name];

      // If we have the item, return it.
      if (item !== undefined) {
        return item;
      } else {
        // If we don't, return a promise that we will resolve once we receive the item.
        var resolve = void 0;
        var promise = new _promise2.default(function (res) {
          return resolve = res;
        });
        promise.manualResolve = resolve;
        this._map[name] = promise;
        return promise;
      }
    }
    /**
     * Gets all objects stored in the context.
     * @return {Object} - A new map of context-stored items.
     */

  }, {
    key: 'getAll',
    value: function getAll() {
      return (0, _assign2.default)({}, this._map);
    }
    /**
     * Stores an item in the context instance.
     * @param {string} name - The name of what we are storing
     * @param {any} item - The item can be of any type.
     * @return {boolean} - The result of the operation
     */

  }, {
    key: 'put',
    value: function put(name, item) {
      var _this = this;

      if (typeof name !== 'string' || typeof name === 'string' && !name.length || item === undefined) return false; // We can't store this.

      var existingItem = this._map[name];

      // Item already exists and no one is waiting for the item. Abort and return false.
      if (existingItem !== undefined && typeof existingItem.manualResolve !== 'function') return false;

      // Someone is waiting for this item, resolve to it.
      if (thenable(existingItem) && existingItem.manualResolve) existingItem.manualResolve(item);

      // We are storing a promise, when resolving save the item. On error, clean up the item.
      if (thenable(item)) item.then(function (item) {
        _this._map[name] = item;
        return item;
      }).catch(function (err) {
        _this._map[name] = undefined;
        return err;
      });

      this._map[name] = item;
      return true;
    }
  }]);
  return Context;
}();

module.exports = Context;


//////////////////
// WEBPACK FOOTER
// ./~/@splitsoftware/splitio/lib/utils/context/index.js
// module id = 734
// module chunks = 10